module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/bb-footer-logo_a1825af.png";